const fb = require('../../firebaseConfig.js')

export default {
    state: {
        purchaseOrderStatuses: [],
        defaultPurchaseOrderStatus: {sequence: 1, value: 'open'}
    },
    getters: {
        purchaseOrderStatuses: (state) => {
            return state.purchaseOrderStatuses
        },
        defaultPurchaseOrderStatus: (state) => {
            return state.defaultPurchaseOrderStatus
        }
    },
    mutations: {
        setPurchaseOrderStatuses(state, val) {
			state.purchaseOrderStatuses = val
		},
        setDefaultPurchaseOrderStatus(state, val) {
            state.defaultPurchaseOrderStatus = val
        }
    },
    actions: {
        async fetchPurchaseOrderStatuses({commit}) {
            await fb.constantsCollection.onSnapshot(querySnapshot => {
                let purchaseOrderStatuses = [];
                querySnapshot.forEach(constant => {
                    if (constant.id == 'purchaseOrderStatuses') {
                        constant.data().values.forEach(status => {
                            purchaseOrderStatuses.push(status)

                        })

                    }
                })
                commit('setDefaultPurchaseOrderStatus', purchaseOrderStatuses[0])
                commit('setPurchaseOrderStatuses', purchaseOrderStatuses)
            })
        },
    }
}